import i18n from 'client/i18n'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'
import { createWebsiteButton } from 'src/shared/entities/website-button/create-website-button'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { ContainerBaseEntityUnionInterface } from 'src/shared/schemas/container-base-entity.schema'
import { getDefaultButtonSettings } from 'src/shared/utils/website-header-utils'

export const createWebsiteButtonFromLibrary = ({
  container,
  locale,
  position = 0,
  options,
  createButton = createWebsiteButton,
}: {
  container: ContainerBaseEntityUnionInterface | OldEntityWithChildIds
  locale: string
  position?: number
  options?: Partial<WebsiteButtonEntityInterface>
  createButton?: typeof createWebsiteButton
}) => {
  const fixedT = i18n.getFixedT(locale)

  const button = createButton(
    container.id,
    fixedT('entities.button.default_text'),
    '',
    container.masterBlockId,
  )

  return {
    [container.id]: {
      ...container,
      childIds: insertChild(container.childIds, button.id, position),
    },
    [button.id]: {
      ...button,
      ...options,
      ...getDefaultButtonSettings,
    },
  }
}
